<div rtBlock="panel">
    @if (showExtras()) {
        <div rtElem="actions">
            <button
                rtElem="action-btn"
                rtButton
                type="button"
                [rtMod]="{ share: true }"
                [disabled]="justCopied()"
                (click)="shareRequested.emit()">
                <span i18n="@@btnShareConfig">Поделиться</span>
                @if (justCopied()) {
                    <svg
                        rtElem="action-icon"
                        viewBox="0 0 24 24"
                        width="14"
                        height="14"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        aria-hidden="true">
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                } @else {
                    <svg
                        rtElem="action-icon"
                        viewBox="0 0 24 24"
                        width="14"
                        height="14"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        aria-hidden="true">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                    </svg>
                }
            </button>
            <button
                rtElem="action-btn"
                rtButton
                type="button"
                qa-dataid="params-export"
                i18n="@@btnExportConfig"
                [rtMod]="{ save: true }"
                (click)="exportRequested.emit()">
                Сохранить
            </button>
            <button rtElem="action-btn" rtButton type="button" i18n="@@btnImportConfig" (click)="fileInput.click()">Загрузить .json</button>
            <button
                rtElem="action-btn"
                rtButton
                type="button"
                qa-dataid="params-export-dxf"
                i18n="@@btnExportDxf"
                [disabled]="!result()"
                (click)="dxfRequested.emit()">
                DXF для CAD
            </button>
            <button
                rtElem="action-btn"
                rtButton
                type="button"
                qa-dataid="params-export-parts"
                i18n="@@btnExportParts"
                [disabled]="!result()"
                (click)="partsRequested.emit()">
                DXF по деталям
            </button>
            <!-- native-ok: the kit file input draws its own outlined button with an icon and a file card list, while the site keeps its load button next to it and reads the file at once (owner decision: keep the site look) -->
            <input #fileInput type="file" accept=".json" hidden (change)="onFileSelected($event)" />
        </div>
        <div
            rtElem="dropzone"
            qa-dataid="params-dropzone"
            [rtMod]="{ active: dropActive() }"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave()"
            (drop)="onDrop($event)">
            <span i18n="@@dropzoneHint">или перетащите .json</span>
        </div>
    }

    <h2 rtElem="title" i18n="@@sectionParams">Параметры лестницы</h2>

    <!-- Stair type -->
    <section rtBlock="section">
        <h3 rtElem="title">
            <span rtElem="title-label">
                <ng-container i18n="@@labelStairType">Тип лестницы</ng-container>
                <sc-info-icon
                    [link]="['/blog']"
                    [popoverContent]="hintTpl"
                    [popoverContext]="{ text: blogOverviewText, link: ['/blog'] }" />
            </span>
            <button
                rtElem="reset-btn"
                rtButton
                type="button"
                i18n-aria-label="@@btnResetConfig"
                aria-label="Сбросить настройки"
                i18n-rtTooltip="@@btnResetConfig"
                rtTooltip="Сбросить настройки"
                (click)="resetConfig()">
                ↺
            </button>
        </h3>
        <div rtBlock="type-cards">
            @for (stairType of stairTypes; track stairType.value) {
                <button
                    rtBlock="type-card"
                    rtButton
                    type="button"
                    [attr.aria-label]="stairType.label"
                    [rtMod]="{ active: config().type === stairType.value }"
                    (click)="setType(stairType.value)">
                    <span rtElem="icon">
                        @switch (stairType.value) {
                            @case ('straight') {
                                <svg
                                    viewBox="0 0 32 32"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <line x1="8" y1="28" x2="8" y2="4" />
                                    <line x1="24" y1="28" x2="24" y2="4" />
                                    <line x1="8" y1="24" x2="24" y2="24" />
                                    <line x1="8" y1="18" x2="24" y2="18" />
                                    <line x1="8" y1="12" x2="24" y2="12" />
                                    <line x1="8" y1="6" x2="24" y2="6" />
                                </svg>
                            }
                            @case ('l-shape') {
                                <svg
                                    viewBox="0 0 32 32"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <line x1="6" y1="4" x2="26" y2="4" />
                                    <line x1="6" y1="4" x2="6" y2="14" />
                                    <line x1="16" y1="4" x2="16" y2="14" />
                                    <line x1="6" y1="8" x2="16" y2="8" />
                                    <line x1="6" y1="12" x2="16" y2="12" />
                                    <line x1="26" y1="4" x2="26" y2="28" />
                                    <line x1="16" y1="14" x2="16" y2="28" />
                                    <line x1="16" y1="18" x2="26" y2="18" />
                                    <line x1="16" y1="22" x2="26" y2="22" />
                                    <line x1="16" y1="26" x2="26" y2="26" />
                                </svg>
                            }
                            @case ('u-shape') {
                                <svg
                                    viewBox="0 0 32 32"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <!-- Left flight down -->
                                    <line x1="3" y1="4" x2="3" y2="28" />
                                    <line x1="12" y1="4" x2="12" y2="28" />
                                    <line x1="3" y1="8" x2="12" y2="8" />
                                    <line x1="3" y1="12" x2="12" y2="12" />
                                    <line x1="3" y1="16" x2="12" y2="16" />
                                    <!-- Right flight up -->
                                    <line x1="20" y1="4" x2="20" y2="28" />
                                    <line x1="29" y1="4" x2="29" y2="28" />
                                    <line x1="20" y1="16" x2="29" y2="16" />
                                    <line x1="20" y1="20" x2="29" y2="20" />
                                    <line x1="20" y1="24" x2="29" y2="24" />
                                    <!-- Landing connects bottom -->
                                    <line x1="3" y1="28" x2="29" y2="28" />
                                </svg>
                            }
                            @case ('spiral') {
                                <svg
                                    viewBox="0 0 32 32"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <path
                                        d="M16 2 A14 14 0 0 1 30 16 A14 14 0 0 1 16 30 A12 12 0 0 1 4 18 A10 10 0 0 1 14 8 A8 8 0 0 1 22 16 A6 6 0 0 1 16 22 A4 4 0 0 1 12 18 A2 2 0 0 1 14 16" />
                                </svg>
                            }
                        }
                    </span>
                    <span rtElem="label">{{ stairType.label }}</span>
                </button>
            }
        </div>
        <div rtElem="type-active">{{ activeStairTypeLabel() }}</div>
    </section>

    <!-- Room dimensions -->
    <section rtBlock="section">
        <h3 rtElem="title" i18n="@@sectionRoom">Помещение</h3>
        <label rtBlock="field">
            <div rtElem="lbl">
                <span rtElem="lbl-text">
                    <span i18n="@@labelRoomLength">Длина комнаты</span>
                    <sc-info-icon [link]="['/blog', 'room-length']" [popoverContent]="hintTpl" [popoverContext]="{ slug: 'room-length' }" />
                </span>
                <span rtElem="val">
                    {{ config().roomLength }}
                    <small>мм</small>
                </span>
            </div>
            <div rtElem="bar">
                <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                <input
                    type="range"
                    [min]="constraints.room.length.min"
                    [max]="constraints.room.length.max"
                    [step]="constraints.room.length.step"
                    [ngModel]="config().roomLength"
                    (ngModelChange)="emitField('roomLength', $event)" />
                <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
            </div>
        </label>
        <label rtBlock="field">
            <div rtElem="lbl">
                <span rtElem="lbl-text">
                    <span i18n="@@labelRoomWidth">Ширина комнаты</span>
                    <sc-info-icon [link]="['/blog', 'room-width']" [popoverContent]="hintTpl" [popoverContext]="{ slug: 'room-width' }" />
                </span>
                <span rtElem="val">
                    {{ config().roomWidth }}
                    <small>мм</small>
                </span>
            </div>
            <div rtElem="bar">
                <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                <input
                    type="range"
                    [min]="constraints.room.width.min"
                    [max]="constraints.room.width.max"
                    [step]="constraints.room.width.step"
                    [ngModel]="config().roomWidth"
                    (ngModelChange)="emitField('roomWidth', $event)" />
                <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
            </div>
        </label>
        <label rtBlock="field">
            <div rtElem="lbl">
                <span rtElem="lbl-text">
                    <span i18n="@@labelFloorHeight">Высота этажа</span>
                    <sc-info-icon
                        [link]="['/blog', 'floor-height']"
                        [popoverContent]="hintTpl"
                        [popoverContext]="{ slug: 'floor-height' }" />
                </span>
                <span rtElem="val">
                    {{ config().floorHeight }}
                    <small>мм</small>
                </span>
            </div>
            <div rtElem="bar">
                <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                <input
                    type="range"
                    [max]="constraints.room.floorHeight.max"
                    [step]="constraints.room.floorHeight.step"
                    [min]="config().type === 'spiral' ? constraints.spiral.floorHeightMin : constraints.room.floorHeight.min"
                    [ngModel]="config().floorHeight"
                    (ngModelChange)="emitField('floorHeight', $event)" />
                <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
            </div>
        </label>
        <label rtBlock="field">
            <div rtElem="lbl">
                <span rtElem="lbl-text">
                    <span i18n="@@labelFloorThickness">Толщина перекрытия</span>
                    <sc-info-icon
                        [link]="['/blog', 'slab-thickness']"
                        [popoverContent]="hintTpl"
                        [popoverContext]="{ slug: 'slab-thickness' }" />
                </span>
                <span rtElem="val">
                    {{ config().floorThickness }}
                    <small>мм</small>
                </span>
            </div>
            <div rtElem="bar">
                <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                <input
                    type="range"
                    [min]="constraints.room.floorThickness.min"
                    [max]="constraints.room.floorThickness.max"
                    [step]="constraints.room.floorThickness.step"
                    [ngModel]="config().floorThickness"
                    (ngModelChange)="emitField('floorThickness', $event)" />
                <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
            </div>
        </label>
    </section>

    <!-- Opening -->
    <section rtBlock="section">
        <h3 rtElem="title" i18n="@@sectionOpening">Проём</h3>
        <sc-toggle
            i18n-label="@@labelOpeningLocked"
            label="Зафиксировать проём"
            [checked]="config().openingLocked"
            (checkedChange)="emitField('openingLocked', $event)">
            <sc-info-icon
                slot="hint"
                [link]="['/blog', 'opening-lock']"
                [popoverContent]="hintTpl"
                [popoverContext]="{ slug: 'opening-lock' }" />
        </sc-toggle>
        @if (config().type === 'spiral') {
            <label rtBlock="field">
                <div rtElem="lbl">
                    <span i18n="@@labelOpeningDiameter">Диаметр проёма</span>
                    <span rtElem="val">
                        {{ config().openingWidth }}
                        <small>мм</small>
                    </span>
                </div>
                <div rtElem="bar">
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                    <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                    <input
                        type="range"
                        [step]="constraints.spiral.diameter.step"
                        [min]="constraints.spiral.diameter.min + constraints.spiral.openingMargin"
                        [max]="Math.min(config().roomWidth - config().openingX, config().roomLength - config().openingZ)"
                        [ngModel]="config().openingWidth"
                        (ngModelChange)="emitSpiralOpeningDiameter($event)" />
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
                </div>
            </label>
        } @else {
            <label rtBlock="field">
                <div rtElem="lbl">
                    <span rtElem="lbl-text">
                        <span i18n="@@labelOpeningLength">Длина проёма</span>
                        <sc-info-icon
                            [link]="['/blog', 'opening-length']"
                            [popoverContent]="hintTpl"
                            [popoverContext]="{ slug: 'opening-length' }" />
                    </span>
                    <span rtElem="val">
                        {{ config().openingLength }}
                        <small>мм</small>
                    </span>
                </div>
                <div rtElem="bar">
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                    <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                    <input
                        type="range"
                        [min]="constraints.opening.length.min"
                        [step]="constraints.opening.length.step"
                        [ngModel]="config().openingLength"
                        [max]="Math.min(constraints.opening.length.max, config().roomLength)"
                        (ngModelChange)="emitField('openingLength', $event)" />
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
                </div>
            </label>
            <label rtBlock="field">
                <div rtElem="lbl">
                    <span rtElem="lbl-text">
                        <span i18n="@@labelOpeningWidth">Ширина проёма</span>
                        <sc-info-icon
                            [link]="['/blog', 'opening-width']"
                            [popoverContent]="hintTpl"
                            [popoverContext]="{ slug: 'opening-width' }" />
                    </span>
                    <span rtElem="val">
                        {{ config().openingWidth }}
                        <small>мм</small>
                    </span>
                </div>
                <div rtElem="bar">
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                    <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                    <input
                        type="range"
                        [min]="constraints.opening.width.min"
                        [step]="constraints.opening.width.step"
                        [ngModel]="config().openingWidth"
                        [max]="Math.min(constraints.opening.width.max, config().roomWidth)"
                        (ngModelChange)="emitField('openingWidth', $event)" />
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
                </div>
            </label>
            <label rtBlock="field">
                <div rtElem="lbl">
                    <span rtElem="lbl-text">
                        <span i18n="@@labelPositionX">Позиция X</span>
                        <sc-info-icon
                            [link]="['/blog', 'opening-position-x']"
                            [popoverContent]="hintTpl"
                            [popoverContext]="{ slug: 'opening-position-x' }" />
                    </span>
                    <span rtElem="val">
                        {{ config().openingX }}
                        <small>мм</small>
                    </span>
                </div>
                <div rtElem="bar">
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                    <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                    <input
                        type="range"
                        min="0"
                        [step]="constraints.opening.positionStep"
                        [ngModel]="config().openingX"
                        [max]="config().roomWidth - config().openingWidth"
                        (ngModelChange)="emitField('openingX', $event)" />
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
                </div>
            </label>
            <label rtBlock="field">
                <div rtElem="lbl">
                    <span rtElem="lbl-text">
                        <span i18n="@@labelPositionZ">Отступ от дальней стены</span>
                        <sc-info-icon
                            [link]="['/blog', 'opening-position-y']"
                            [popoverContent]="hintTpl"
                            [popoverContext]="{ slug: 'opening-position-y' }" />
                    </span>
                    <span rtElem="val">
                        {{ config().roomLength - config().openingZ - config().openingLength }}
                        <small>мм</small>
                    </span>
                </div>
                <div rtElem="bar">
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                    <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                    <input
                        type="range"
                        min="0"
                        [step]="constraints.opening.positionStep"
                        [ngModel]="config().roomLength - config().openingZ - config().openingLength"
                        [max]="config().roomLength - Math.max(result()?.totalRun ?? config().openingLength, config().openingLength)"
                        (ngModelChange)="emitDisplayY($event)" />
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
                </div>
            </label>
        }
    </section>

    <!-- Spiral parameters -->
    @if (config().type === 'spiral') {
        <section rtBlock="section">
            <h3 rtElem="title" i18n="@@sectionSpiral">Винтовая лестница</h3>
            <label rtBlock="field">
                <div rtElem="lbl">
                    <span i18n="@@labelSpiralDiameter">Диаметр лестницы</span>
                    <span rtElem="val">
                        {{ config().spiralDiameter ?? constraints.spiral.defaultDiameter }}
                        <small>мм</small>
                    </span>
                </div>
                <div rtElem="bar">
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                    <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                    <input
                        type="range"
                        [min]="constraints.spiral.diameter.min"
                        [max]="constraints.spiral.diameter.max"
                        [step]="constraints.spiral.diameter.step"
                        [ngModel]="config().spiralDiameter ?? constraints.spiral.defaultDiameter"
                        (ngModelChange)="emitField('spiralDiameter', $event)" />
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
                </div>
            </label>
            <div rtBlock="field">
                <span i18n="@@labelTurnDirection">Направление</span>
                <div rtBlock="chips">
                    <button
                        rtBlock="chip"
                        rtButton
                        type="button"
                        i18n="@@turnDirectionLeft"
                        [rtMod]="{ on: config().turnDirection === 'left' }"
                        (click)="emitField('turnDirection', 'left')">
                        Налево
                    </button>
                    <button
                        rtBlock="chip"
                        rtButton
                        type="button"
                        i18n="@@turnDirectionRight"
                        [rtMod]="{ on: config().turnDirection === 'right' }"
                        (click)="emitField('turnDirection', 'right')">
                        Направо
                    </button>
                </div>
            </div>
        </section>
    }

    <!-- Stair dimensions -->
    <section rtBlock="section">
        <h3 rtElem="title" i18n="@@sectionStair">Лестница</h3>
        @if (false) {
            <label rtBlock="field">
                <div rtElem="lbl">
                    <span i18n="@@labelStairAngle">Угол наклона</span>
                    <span rtElem="val">
                        {{ stairAngleDisplay() }}
                        <small>°</small>
                    </span>
                </div>
                <span rtElem="hint" i18n="@@hintStairAngleTarget">целевое значение — уточняется после расчёта ступеней</span>
                <div rtElem="bar">
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                    <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                    <input
                        type="range"
                        [min]="angleConstraint().min"
                        [max]="angleConstraint().max"
                        [step]="angleConstraint().step"
                        [ngModel]="stairAngleDisplay()"
                        (ngModelChange)="emitField('stairAngle', $event)" />
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
                </div>
            </label>
        }
        @if (config().type !== 'spiral') {
            <label rtBlock="field">
                <div rtElem="lbl">
                    <span rtElem="lbl-text">
                        <span i18n="@@labelStairWidth">Ширина марша</span>
                        <sc-info-icon
                            [link]="['/blog', 'march-width']"
                            [popoverContent]="hintTpl"
                            [popoverContext]="{ slug: 'march-width' }" />
                    </span>
                    <span rtElem="val">
                        {{ config().stairWidth }}
                        <small>мм</small>
                    </span>
                </div>
                <div rtElem="bar">
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                    <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                    <input
                        type="range"
                        [min]="constraints.stair.width.min"
                        [step]="constraints.stair.width.step"
                        [ngModel]="config().stairWidth"
                        [max]="config().openingWidth"
                        (ngModelChange)="emitField('stairWidth', $event)" />
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
                </div>
            </label>
        }
        <label rtBlock="field">
            <div rtElem="lbl">
                <span rtElem="lbl-text">
                    <span i18n="@@labelTreadThickness">Толщина ступени</span>
                    <sc-info-icon
                        [link]="['/blog', 'tread-thickness']"
                        [popoverContent]="hintTpl"
                        [popoverContext]="{ slug: 'tread-thickness' }" />
                </span>
                <span rtElem="val">
                    {{ config().treadThickness }}
                    <small>мм</small>
                </span>
            </div>
            <div rtElem="bar">
                <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                <input
                    type="range"
                    [min]="constraints.stair.treadThickness.min"
                    [max]="constraints.stair.treadThickness.max"
                    [step]="constraints.stair.treadThickness.step"
                    [ngModel]="config().treadThickness"
                    (ngModelChange)="emitField('treadThickness', $event)" />
                <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
            </div>
        </label>
        <label rtBlock="field">
            <div rtElem="lbl">
                <span rtElem="lbl-text">
                    <span i18n="@@labelNoseLength">Свес проступи</span>
                    <sc-info-icon
                        [link]="['/blog', 'tread-overhang']"
                        [popoverContent]="hintTpl"
                        [popoverContext]="{ slug: 'tread-overhang' }" />
                </span>
                <span rtElem="val">
                    {{ config().noseLength }}
                    <small>мм</small>
                </span>
            </div>
            <div rtElem="bar">
                <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                <input
                    type="range"
                    [min]="constraints.stair.noseLength.min"
                    [max]="constraints.stair.noseLength.max"
                    [step]="constraints.stair.noseLength.step"
                    [ngModel]="config().noseLength"
                    (ngModelChange)="emitField('noseLength', $event)" />
                <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
            </div>
        </label>
        @if (config().type !== 'spiral') {
            <div rtBlock="field">
                <span rtElem="lbl-text">
                    <span i18n="@@labelStringerType">Тип несущего элемента</span>
                    <sc-info-icon
                        [link]="['/blog', 'stringer-type']"
                        [popoverContent]="hintTpl"
                        [popoverContext]="{ slug: 'stringer-type' }" />
                </span>
                <div rtBlock="chips">
                    <button
                        rtBlock="chip"
                        rtButton
                        type="button"
                        i18n="@@stringerTypeTetiva"
                        [rtMod]="{ on: config().stringerType === 'tetiva' }"
                        (click)="emitField('stringerType', 'tetiva')">
                        Тетива
                    </button>
                    <button
                        rtBlock="chip"
                        rtButton
                        type="button"
                        i18n="@@stringerTypeKosour"
                        [rtMod]="{ on: config().stringerType === 'kosour' }"
                        (click)="emitField('stringerType', 'kosour')">
                        Косоур
                    </button>
                </div>
            </div>
        }
        <sc-toggle
            qa-dataid="risers-enabled"
            i18n-label="@@labelRisersEnabled"
            label="С подступенками"
            [checked]="config().risersEnabled"
            (checkedChange)="emitField('risersEnabled', $event)" />
        @if (config().type === 'u-shape') {
            <label rtBlock="field">
                <div rtElem="lbl">
                    <span i18n="@@labelFlightGap">Зазор между маршами</span>
                    <span rtElem="val">
                        {{ config().flightGap }}
                        <small>мм</small>
                    </span>
                </div>
                <div rtElem="bar">
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                    <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                    <input
                        type="range"
                        [min]="constraints.uShape.flightGap.min"
                        [max]="Math.max(constraints.uShape.flightGap.min, config().openingWidth - 2 * config().stairWidth)"
                        [step]="constraints.uShape.flightGap.step"
                        [ngModel]="config().flightGap"
                        (ngModelChange)="emitField('flightGap', $event)" />
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
                </div>
            </label>
        }
    </section>

    <!-- Turn settings (L-shape / U-shape) -->
    @if (config().type === 'l-shape' || config().type === 'u-shape') {
        <section rtBlock="section">
            <h3 rtElem="title" i18n="@@sectionTurn">Поворот</h3>
            <div rtBlock="field">
                <span i18n="@@labelTurnDirection">Направление</span>
                <div rtBlock="chips">
                    <button
                        rtBlock="chip"
                        rtButton
                        type="button"
                        i18n="@@turnDirectionLeft"
                        [rtMod]="{ on: config().turnDirection === 'left' }"
                        (click)="emitField('turnDirection', 'left')">
                        Налево
                    </button>
                    <button
                        rtBlock="chip"
                        rtButton
                        type="button"
                        i18n="@@turnDirectionRight"
                        [rtMod]="{ on: config().turnDirection === 'right' }"
                        (click)="emitField('turnDirection', 'right')">
                        Направо
                    </button>
                </div>
            </div>
            <div rtBlock="field">
                <span i18n="@@labelTurnType">Тип поворота</span>
                <div rtBlock="chips">
                    <button
                        rtBlock="chip"
                        rtButton
                        type="button"
                        i18n="@@turnTypeLanding"
                        [rtMod]="{ on: config().turnType === 'landing' }"
                        (click)="emitField('turnType', 'landing')">
                        Площадка
                    </button>
                    <button
                        rtBlock="chip"
                        rtButton
                        type="button"
                        i18n="@@turnTypeWinder"
                        [rtMod]="{ on: config().turnType === 'winder' }"
                        (click)="emitField('turnType', 'winder')">
                        Забежные ступени
                    </button>
                </div>
            </div>
            <label rtBlock="field">
                <div rtElem="lbl">
                    <span i18n="@@labelStepsBeforeTurn">Ступеней до поворота</span>
                    <span rtElem="val">{{ turnAtStepDisplay() }}</span>
                </div>
                <div rtElem="bar">
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                    <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                    <input
                        type="range"
                        min="0"
                        step="1"
                        [max]="turnAtStepMax"
                        [ngModel]="turnAtStepDisplay()"
                        (ngModelChange)="emitField('turnAtStep', $event)" />
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
                </div>
            </label>
        </section>
    }

    <!-- Railing -->
    <section rtBlock="section">
        <h3 rtElem="title" i18n="@@sectionRailing">Ограждения</h3>
        <sc-toggle
            i18n-label="@@labelRailingEnabled"
            label="Установить ограждения"
            [checked]="config().railing.enabled"
            (checkedChange)="emitRailingField('enabled', $event)" />
        @if (config().railing.enabled) {
            <sc-toggle
                i18n-label="@@labelUpperRailing"
                label="Верхнее ограждение"
                [checked]="config().railing.upperEnabled"
                (checkedChange)="emitRailingField('upperEnabled', $event)" />
            @if (config().type !== 'spiral') {
                <div rtBlock="field">
                    <span i18n="@@labelRailingSides">Расположение</span>
                    <div rtBlock="chips">
                        <button
                            rtBlock="chip"
                            rtButton
                            type="button"
                            i18n="@@railingSideBoth"
                            [rtMod]="{ on: config().railing.sides === 'both' }"
                            (click)="emitRailingField('sides', 'both')">
                            С двух сторон
                        </button>
                        <button
                            rtBlock="chip"
                            rtButton
                            type="button"
                            i18n="@@railingSideLeft"
                            [rtMod]="{ on: config().railing.sides === 'left' }"
                            (click)="emitRailingField('sides', 'left')">
                            Слева
                        </button>
                        <button
                            rtBlock="chip"
                            rtButton
                            type="button"
                            i18n="@@railingSideRight"
                            [rtMod]="{ on: config().railing.sides === 'right' }"
                            (click)="emitRailingField('sides', 'right')">
                            Справа
                        </button>
                    </div>
                </div>
            }
            <label rtBlock="field">
                <div rtElem="lbl">
                    <span i18n="@@labelRailingHeight">Высота ограждения</span>
                    <span rtElem="val">
                        {{ config().railing.height }}
                        <small>мм</small>
                    </span>
                </div>
                <div rtElem="bar">
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                    <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                    <input
                        type="range"
                        [min]="constraints.railing.height.min"
                        [max]="constraints.railing.height.max"
                        [step]="constraints.railing.height.step"
                        [ngModel]="config().railing.height"
                        (ngModelChange)="emitRailingField('height', $event)"
                        (blur)="clampRailingOnBlur('height')" />
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
                </div>
            </label>
            <label rtBlock="field">
                <div rtElem="lbl">
                    <span i18n="@@labelHandrailWidth">Ширина поручня</span>
                    <span rtElem="val">
                        {{ config().railing.handrailWidth }}
                        <small>мм</small>
                    </span>
                </div>
                <div rtElem="bar">
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                    <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                    <input
                        type="range"
                        [min]="constraints.railing.handrailWidth.min"
                        [max]="constraints.railing.handrailWidth.max"
                        [step]="constraints.railing.handrailWidth.step"
                        [ngModel]="config().railing.handrailWidth"
                        (ngModelChange)="emitRailingField('handrailWidth', $event)"
                        (blur)="clampRailingOnBlur('handrailWidth')" />
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
                </div>
            </label>
            <label rtBlock="field">
                <div rtElem="lbl">
                    <span i18n="@@labelBalusterWidth">Ширина балясин</span>
                    <span rtElem="val">
                        {{ config().railing.balusterWidth }}
                        <small>мм</small>
                    </span>
                </div>
                <div rtElem="bar">
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                    <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                    <input
                        type="range"
                        [min]="constraints.railing.balusterWidth.min"
                        [max]="constraints.railing.balusterWidth.max"
                        [step]="constraints.railing.balusterWidth.step"
                        [ngModel]="config().railing.balusterWidth"
                        (ngModelChange)="emitRailingField('balusterWidth', $event)"
                        (blur)="clampRailingOnBlur('balusterWidth')" />
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
                </div>
            </label>
            <label rtBlock="field">
                <div rtElem="lbl">
                    <span i18n="@@labelBalusterSpacing">Шаг балясин</span>
                    <span rtElem="val">
                        {{ config().railing.balusterSpacing }}
                        <small>мм</small>
                    </span>
                </div>
                <div rtElem="bar">
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                    <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                    <input
                        type="range"
                        [min]="constraints.railing.balusterSpacing.min"
                        [max]="constraints.railing.balusterSpacing.max"
                        [step]="constraints.railing.balusterSpacing.step"
                        [ngModel]="config().railing.balusterSpacing"
                        (ngModelChange)="emitRailingField('balusterSpacing', $event)"
                        (blur)="clampRailingOnBlur('balusterSpacing')" />
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
                </div>
            </label>
            <label rtBlock="field">
                <div rtElem="lbl">
                    <span i18n="@@labelPostWidth">Ширина столбов</span>
                    <span rtElem="val">
                        {{ config().railing.postWidth }}
                        <small>мм</small>
                    </span>
                </div>
                <div rtElem="bar">
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, -1)">−</button>
                    <!-- native-ok: the kit has no range slider; a number field would drop the dragging and the site look (owner decision: keep the site look) -->
                    <input
                        type="range"
                        [min]="constraints.railing.postWidth.min"
                        [max]="constraints.railing.postWidth.max"
                        [step]="constraints.railing.postWidth.step"
                        [ngModel]="config().railing.postWidth"
                        (ngModelChange)="emitRailingField('postWidth', $event)"
                        (blur)="clampRailingOnBlur('postWidth')" />
                    <button rtElem="step" rtButton type="button" tabindex="-1" (click)="stepFromBar($event, 1)">+</button>
                </div>
            </label>
        }
    </section>

    <!-- Materials -->
    <section rtBlock="section">
        <h3 rtElem="title" i18n="@@sectionMaterials">Материалы</h3>
        <div rtBlock="field">
            <span i18n="@@labelTreads">Ступени</span>
            <div rtBlock="chips">
                @for (material of materials; track material.id) {
                    <button
                        rtBlock="chip"
                        rtButton
                        type="button"
                        qa-dataid="material-tread"
                        [attr.data-material]="material.id"
                        [rtMod]="{ on: config().treadMaterialId === material.id }"
                        (click)="emitField('treadMaterialId', material.id)">
                        {{ material.name }}
                    </button>
                }
            </div>
        </div>
        @if (config().risersEnabled) {
            <div rtBlock="field">
                <span i18n="@@labelRisers">Подступенки</span>
                <div rtBlock="chips">
                    @for (material of materials; track material.id) {
                        <button
                            rtBlock="chip"
                            rtButton
                            type="button"
                            qa-dataid="material-riser"
                            [attr.data-material]="material.id"
                            [rtMod]="{ on: config().riserMaterialId === material.id }"
                            (click)="emitField('riserMaterialId', material.id)">
                            {{ material.name }}
                        </button>
                    }
                </div>
            </div>
        }
        <div rtBlock="field">
            <span i18n="@@labelStringers">Несущие элементы</span>
            <div rtBlock="chips">
                @for (material of materials; track material.id) {
                    <button
                        rtBlock="chip"
                        rtButton
                        type="button"
                        qa-dataid="material-stringer"
                        [attr.data-material]="material.id"
                        [rtMod]="{ on: config().stringerMaterialId === material.id }"
                        (click)="emitField('stringerMaterialId', material.id)">
                        {{ material.name }}
                    </button>
                }
            </div>
        </div>
        @if (config().railing.enabled) {
            <div rtBlock="field">
                <span i18n="@@labelHandrailMaterial">Поручни</span>
                <div rtBlock="chips">
                    @for (material of materials; track material.id) {
                        <button
                            rtBlock="chip"
                            rtButton
                            type="button"
                            qa-dataid="material-handrail"
                            [attr.data-material]="material.id"
                            [rtMod]="{ on: config().handrailMaterialId === material.id }"
                            (click)="emitField('handrailMaterialId', material.id)">
                            {{ material.name }}
                        </button>
                    }
                </div>
            </div>
            <div rtBlock="field">
                <span i18n="@@labelBalusterMaterial">Балясины и столбы</span>
                <div rtBlock="chips">
                    @for (material of materials; track material.id) {
                        <button
                            rtBlock="chip"
                            rtButton
                            type="button"
                            qa-dataid="material-baluster"
                            [attr.data-material]="material.id"
                            [rtMod]="{ on: config().balusterMaterialId === material.id }"
                            (click)="emitField('balusterMaterialId', material.id)">
                            {{ material.name }}
                        </button>
                    }
                </div>
            </div>
        }
    </section>

    <!-- Results summary -->
    @if (showExtras() && result(); as calcResult) {
        <section rtBlock="section" [class]="['results'] | concatClasses">
            <h3 rtElem="title" i18n="@@sectionResults">Результат расчёта</h3>
            <div rtBlock="result-row">
                <span i18n="@@resultStepCount">Количество ступеней</span>
                <strong>{{ calcResult.stepCount }}</strong>
            </div>
            <div rtBlock="result-row">
                <span i18n="@@resultRiserHeight">Высота подступенка</span>
                <strong>
                    {{ calcResult.riserHeight }}
                    <ng-container i18n="@@unitMm">мм</ng-container>
                </strong>
            </div>
            <div rtBlock="result-row">
                <span i18n="@@resultTreadDepth">Глубина проступи</span>
                <strong>
                    {{ calcResult.treadDepth }}
                    <ng-container i18n="@@unitMm">мм</ng-container>
                </strong>
            </div>
            <div rtBlock="result-row">
                <span i18n="@@resultAngle">Угол наклона</span>
                <strong>{{ calcResult.stairAngle }}°</strong>
            </div>
            <div rtBlock="result-row">
                <span i18n="@@resultHeadroom">Просвет</span>
                <strong>
                    {{ calcResult.headroom }}
                    <ng-container i18n="@@unitMm">мм</ng-container>
                </strong>
            </div>
            <div rtBlock="result-row">
                <span i18n="@@resultBlondel">Формула Блонделя</span>
                <strong>
                    {{ calcResult.blondelValue }}
                    <ng-container i18n="@@unitMm">мм</ng-container>
                </strong>
            </div>
            <div rtBlock="result-row">
                <span i18n="@@resultWoodVolume">Объём дерева</span>
                <strong>
                    {{ calcResult.woodVolumeM3 }}
                    <ng-container i18n="@@unitM3">м³</ng-container>
                </strong>
            </div>
            <div rtBlock="result-row">
                <span i18n="@@resultWeight">Вес (примерно)</span>
                <strong>
                    {{ calcResult.estimatedWeightKg }}
                    <ng-container i18n="@@unitKg">кг</ng-container>
                </strong>
            </div>
            @if (showCost) {
                <div rtBlock="result-row" [rtMod]="{ highlight: true }">
                    <span i18n="@@resultCost">Стоимость материала (ориент.)</span>
                    <strong>
                        {{ calcResult.estimatedCostUsd }}
                        <ng-container i18n="@@unitUsd">$</ng-container>
                    </strong>
                </div>
            }
        </section>

        @if (calcResult.validation.length) {
            <section rtBlock="section" [class]="['results'] | concatClasses">
                <h3 rtElem="title" i18n="@@sectionValidation">Проверка норм</h3>
                @for (validationItem of calcResult.validation; track validationItem.code) {
                    <div
                        rtBlock="validation-item"
                        [rtMod]="{
                            ok: validationItem.severity === 'ok',
                            warning: validationItem.severity === 'warning',
                            error: validationItem.severity === 'error',
                        }">
                        <span rtElem="icon">
                            @switch (validationItem.severity) {
                                @case ('ok') {
                                    ✓
                                }
                                @case ('warning') {
                                    ⚠
                                }
                                @case ('error') {
                                    ✗
                                }
                            }
                        </span>
                        <span>{{ validationItem.message }}</span>
                    </div>
                }
            </section>
        }
    }

    @if (showExtras()) {
        <footer rtBlock="panel-footer">
            <h3 rtElem="title" i18n="@@sectionFeedback">Обратная связь</h3>
            <sc-feedback-form
                [contextData]="config()"
                (feedbackOpened)="feedbackOpened.emit()"
                (feedbackSubmitted)="feedbackSubmitted.emit()"
                (feedbackFailed)="feedbackFailed.emit($event)" />

            <a rtElem="privacy-link" routerLink="/privacy" i18n="@@footerPrivacyLink">Политика конфиденциальности</a>
        </footer>
    }
</div>

<ng-template #hintTpl let-ctx>
    <div rtBlock="hint-card">
        <p rtElem="desc">{{ ctx.text ?? articleDescriptions[ctx.slug] }}</p>
        <a rtElem="link" target="_blank" rel="noopener" i18n="@@hintDetails" [routerLink]="ctx.link ?? ['/blog', ctx.slug]">Подробнее →</a>
    </div>
</ng-template>
